/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Literacy { 
    readonly id: string;
    /**
     * Zadejte název gramotnosti.
     */
    title: string;
    /**
     * Zadejte krátký popis gramotnosti.
     */
    shortDescription?: string;
    /**
     * Zadejte popis gramotnosti.
     */
    description?: string;
    readonly touchCount: number;
    icon?: string;
}